import IdentificationError from './IdentificationError';
class IdentificationIsNotExpired extends IdentificationError {
    constructor(options) {
        super('Identification is not expired', options);
    }
}
export default IdentificationIsNotExpired;
